import React from "react";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { IconButton } from "@material-ui/core";
import { format } from "date-fns";
/* import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined"; */
/* import CheckCircleOutlineIcon from "@material-ui/icons-material/CheckCircleOutline"; */
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import ManageOrder from "./ManageOrder.jsx";
import MatUITable from "../../../components/MatUITable/MatUITable";
import Heading from "../../../components/Heading/Heading";
import LoadingIndicator from "../../../utils/LoadingIndicator/LoadingIndicator";
import {
  orderLabels,
  dropdownItemsFilter,
  inputItemsFilter,
  adminOrdersColumns,
} from "../../../utils/Data/dataTexts.js";
import { withTranslation } from "react-i18next";
import i18n from "../../../utils/LanguageSelector/i18n";
import axios from "../../../utils/Axios/axiosProxy";
import { CancelOutlined, CheckCircleOutlined } from "@material-ui/icons";

function AdminOrders({ ...props }) {
  const [selectedOrder, setSelectedOrder] = React.useState(null);
  const [orderToDelete, setOrderToDelete] = React.useState({
    orderID: "",
    delete: false,
  });
  const [tableMode, setTableMode] = React.useState(true);
  const [filterBy, setFilterBy] = React.useState({
    complete: "",
    quotesent: "",
    propsalstatus: "",
    payment: "",
    clientname: "",
    datecreated: "",
    _id: "",
    active: "",
  });
  const handleChange = (event) => {
    setFilterBy({ ...filterBy, [event.target.id]: event.target.value });
  };
  const handleDropdown = (event) => {
    setFilterBy({ ...filterBy, [event.target.name]: `${event.target.value}` });
  };
  const createNewOrder = () => {
    axios
      .post("/api/order/blank", {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        props.getOrdersFromDB(localStorage.getItem("JWT"));
        console.log("UPDATE ORDER RESPONSE: ", response.statusText);
      })
      .catch((error) => {
        console.log("UPDATE ORDER ERROR: ", error.response.data);
      })
      .catch((error) => console.log("submitToDB error", error));
  };
  const deleteOrder = (id) => {
    axios
      .delete(`/api/order/${id}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        props.getOrdersFromDB(localStorage.getItem("JWT"));
        console.log("UPDATE ORDER RESPONSE: ", response.statusText);
      })
      .catch((error) => {
        console.log("UPDATE ORDER ERROR: ", error.response.data);
      })
      .catch((error) => console.log("submitToDB error", error));
  };
  const createTableData = (orders) => {
    let rows = [];
    orders.forEach((order) => {
      let match = true;
      order.completelabel =
        order.complete !== undefined
          ? order.complete
            ? i18n.t("general.yes")
            : i18n.t("general.no")
          : i18n.t("matable.processing");
      order.quotedate = order.quotesent
        ? order.quotation.date
        : i18n.t("matable.processing");
      order.proposalstatuslabel =
        orderLabels.proposalstatus[order.proposalstatus];
      order.paymentlabel = orderLabels.payment[order.payment];
      order.activelabel = order.active
        ? i18n.t("general.yes")
        : i18n.t("general.no");
      order.clientname = `${order.contact.firstname} ${order.contact.lastname}`;
      order.datecreated = format(
        new Date(order.datecreated),
        'yyyy-MM-dd HH:mm'
      );
      for (let i in filterBy) {
        if (order[i] !== undefined) {
          let value = `${order[i]}`.toLowerCase();
          let filter = filterBy[i].toLowerCase();
          if (filterBy[i].length !== 0 && !value.match(`${filter}`)) {
            match = false;
          }
        }
      }
      if (match) {
        rows.push(order);
      }
    });
    return rows;
  };
  return (
    <div>
      {props.ordersFetched ? (
        <>
          {tableMode ? (
            <>
              {props.manageOrder ? (
                <div
                  className={
                    window.innerWidth >= 600 ? "MarginHorizontal Row" : "Column"
                  }
                >
                  {inputItemsFilter.map((item) => {
                    return (
                      <TextField
                        style={{ maxWidth: "160px" }}
                        className="MarginRight"
                        id={item.id}
                        placeholder={item.placeholder}
                        variant="outlined"
                        value={filterBy[item.id]}
                        onChange={(event) => handleChange(event)}
                      />
                    );
                  })}
                  {dropdownItemsFilter.map((item) => {
                    return (
                      <FormControl
                        variant="outlined"
                        style={{ minWidth: "140px" }}
                        className="MarginRight"
                      >
                        <InputLabel id="demo-simple-select-outlined-label">
                          {item.label}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          name={item.id}
                          value={filterBy[item.id]}
                          onChange={(event) => handleDropdown(event)}
                          label={item.label}
                        >
                          {item.options.map((i) => {
                            return (
                              <MenuItem value={i.value}>{i.option}</MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    );
                  })}
                </div>
              ) : null}
              <Heading
                title={i18n.t("general.orders")}
                button
                className="ToreaBay Small"
                titleB="New Order"
                onClick={createNewOrder}
              />
              <MatUITable
                paging={true}
                pageSize={10}
                page="adminorders"
                onRowClick={(order) => {
                  setSelectedOrder(order);
                  setTableMode(false);
                }}
                columns={[
                  ...adminOrdersColumns,
                  {
                    get title() {
                      return "Delete";
                    },
                    field: "delete",
                    align: "left",
                    defaultSort: "desc",
                    render: (rowData) => {
                      if (orderToDelete.orderID !== rowData._id) {
                        return (
                          <IconButton
                            onClick={(event) => {
                              event.stopPropagation();
                              setOrderToDelete({
                                ...orderToDelete,
                                orderID: rowData._id,
                                delete: true,
                              });
                            }}
                            style={{
                              padding: "8px",
                            }}
                          >
                            <RemoveCircleOutlineIcon />
                          </IconButton>
                        );
                      }
                      if (
                        orderToDelete.orderID === rowData._id &&
                        orderToDelete.delete
                      ) {
                        return (
                          <>
                            <IconButton
                              onClick={(event) => {
                                event.stopPropagation();
                                deleteOrder(rowData._id);
                                setOrderToDelete({
                                  ...orderToDelete,
                                  orderID: "",
                                  delete: false,
                                });
                              }}
                              style={{
                                padding: "8px",
                              }}
                            >
                              <CheckCircleOutlined />
                            </IconButton>
                            <IconButton
                              onClick={(event) => {
                                event.stopPropagation();
                                setOrderToDelete({
                                  ...orderToDelete,
                                  orderID: "",
                                  delete: false,
                                });
                              }}
                              style={{
                                padding: "8px",
                              }}
                            >
                              <CancelOutlined />
                            </IconButton>
                          </>
                        );
                      }
                    },
                  },
                ]}
                data={createTableData(props.orders)}
              />
            </>
          ) : (
            <div>
              <IconButton
                onClick={() => {
                  setTableMode(true);
                }}
                className="TransparentBlue Small"
              >
                <ArrowBackIcon />
              </IconButton>
              <ManageOrder
                order={selectedOrder}
                getOrdersFromDB={props.getOrdersFromDB}
              />
            </div>
          )}
        </>
      ) : (
        <LoadingIndicator />
      )}
    </div>
  );
}

export default withTranslation()(AdminOrders);
